// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS POUR PROFIL */

.divGlabaleP {
    width: 100%;
    /* height: 100vh; */
}
.colProfilSexion0 {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 7%; /* Distance depuis le haut de la fenêtre */
  z-index: 1;
  
}


.colProfilSexion1 {
    /* background-color: #f0f8ed; */
    border-radius: 1rem;
   margin-bottom: 3.5%;
   width: 100%;
   /* box-shadow: 0 1px 6px rgba(0, 0, 0, 0.10); */
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);


}

.divContain {
    display: flex;
    align-items:start;
    justify-content: start;
    margin: -1.5%;
}

.divText {
    margin-top: -1%;
    margin-left: 3%;
}

.colProfilSexion2 {
    /* background-color: #f0f8ed; */
    border-radius: 1rem;
    width: 100%;
    margin-bottom: 3.5%;
    padding: 0.5%;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

}

.highlight-section {
  /* animation: highlightBorder 2s ease-in-out; */
  border: 1.5px solid #43CE0C !important;
  border-radius: 1rem;
}

/* @keyframes highlightBorder {
  0% {
    border-color: #43CE0C;
  }
  100% {
    border-color: transparent;
  }
} */



/* CSS COMPOSANT UTILISATEUR */
.rowG {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/utilisateurs/utilisateur.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,OAAO,EAAE,0CAA0C;EACnD,UAAU;;AAEZ;;;AAGA;IACI,+BAA+B;IAC/B,mBAAmB;GACpB,mBAAmB;GACnB,WAAW;GACX,+CAA+C;GAC/C,yCAAyC;;;AAG5C;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;GACd,yCAAyC;;AAE5C;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;;;AAIH,8BAA8B;AAC9B;EACE,WAAW;AACb","sourcesContent":["/* CSS POUR PROFIL */\r\n\r\n.divGlabaleP {\r\n    width: 100%;\r\n    /* height: 100vh; */\r\n}\r\n.colProfilSexion0 {\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n  position: sticky;\r\n  top: 7%; /* Distance depuis le haut de la fenêtre */\r\n  z-index: 1;\r\n  \r\n}\r\n\r\n\r\n.colProfilSexion1 {\r\n    /* background-color: #f0f8ed; */\r\n    border-radius: 1rem;\r\n   margin-bottom: 3.5%;\r\n   width: 100%;\r\n   /* box-shadow: 0 1px 6px rgba(0, 0, 0, 0.10); */\r\n   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n\r\n\r\n}\r\n\r\n.divContain {\r\n    display: flex;\r\n    align-items:start;\r\n    justify-content: start;\r\n    margin: -1.5%;\r\n}\r\n\r\n.divText {\r\n    margin-top: -1%;\r\n    margin-left: 3%;\r\n}\r\n\r\n.colProfilSexion2 {\r\n    /* background-color: #f0f8ed; */\r\n    border-radius: 1rem;\r\n    width: 100%;\r\n    margin-bottom: 3.5%;\r\n    padding: 0.5%;\r\n   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n\r\n}\r\n\r\n.highlight-section {\r\n  /* animation: highlightBorder 2s ease-in-out; */\r\n  border: 1.5px solid #43CE0C !important;\r\n  border-radius: 1rem;\r\n}\r\n\r\n/* @keyframes highlightBorder {\r\n  0% {\r\n    border-color: #43CE0C;\r\n  }\r\n  100% {\r\n    border-color: transparent;\r\n  }\r\n} */\r\n\r\n\r\n\r\n/* CSS COMPOSANT UTILISATEUR */\r\n.rowG {\r\n  width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
